import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import World from "@frog/source/models/World.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Travel from "@frog/source/data/games/ember/travel.js"

import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"

export default {
    "slug": "1",
    "stage": {
        "units": require("./units.json"),
        "images": [
            require("../dotgridbg.png"),
            require("./room.png"),
        ],
        "world": World.parse({
            "width": 16,
            "height": 9,
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "text": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }
            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "goodspawn"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    function(stage) {
                        let steps = []

                        const encounterKeys = [1, 2, 3, 4]
                        encounterKeys.forEach((encounterKey, index) => {
                            const spots = Random.shuffle(Object.values(stage.world.spots).filter((spot) => {
                                return Zone.isInBounds(stage.encounters[encounterKey], spot.position)
                                    && spot.tag == "badspawn"
                            }))

                            if(spots.length == 0) return

                            const IMAGES = {
                                "sword": require("@frog/source/assets/images/teach-tactics/mapsprite-punkred.png"),
                                "dagger": require("@frog/source/assets/images/teach-tactics/mapsprite-punkred.png"),
                                "hammer": require("@frog/source/assets/images/teach-tactics/mapsprite-punkgreen.png"),
                                "spear": require("@frog/source/assets/images/teach-tactics/mapsprite-punkblue.png"),
                                "bow": require("@frog/source/assets/images/teach-tactics/mapsprite-punkblue.png"),
                            }

                            const unitCount = 3 // Math.max(2, index + 1)
                            const baseLevel = 2

                            for(let i = 0; i < unitCount; i += 1) {
                                const spot = spots[i]
                                if(spot == undefined) return

                                let level = baseLevel // + (i == 0 ? 1 : 0)
                                const jobKey = Random.element(["sword", "spear", "hammer", "dagger", "bow"])
                                steps.push(Step.deltastage({
                                    "unit": {
                                        "affiliation": "bad",
                                        "title": "Punk",
                                        "subtitle": "Student",
                                        "jobKey": jobKey,
                                        "imageUrl": IMAGES[jobKey],
                                        "maxhealth": (10 * level),
                                        "power": Math.max(0, (10 * (level - 3))),
                                        "level": level,
                                        "position": {
                                            "x": spot.position.x,
                                            "y": spot.position.y,
                                            "z": spot.position.z,
                                        },
                                    }
                                }))
                            }
                        })

                        return steps
                    },
                    Step.flag("modal", null),
                    Step.flag("hud", null),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/teach/chapters/2")},
                    // PlotSteps.HealPlayerPartyScript({"percent": 0}),
                    // PlotSteps.MoveEncounterScript({
                    //     "nextEncounterKey": 2,
                    //     "spotTag": "goodspawn"
                    // })
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript({"percent": 0}),
                    PlotSteps.MoveEncounterScript({
                        "nextEncounterKey": 3,
                        "spotTag": "goodspawn"
                    })
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 3
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript({"percent": 0}),
                    PlotSteps.MoveEncounterScript({
                        "nextEncounterKey": 4,
                        "spotTag": "goodspawn"
                    })
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 4
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/teach/chapters/2")},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.ChapterSuccess({"message": "Failure..."}),
                    {"func": () => Navigation.go("/games/teach/chapters/2")},
                ]
            },
        ]
    },
}
